import { useQuery } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from './queryKeys';

const getHousingStockHouses = async (params) => {
  return await request.get(
    '/HousingStock/houses',
    params,
    'При загрузке домов произошла ошибка',
    []
  );
};

const useHousingStockHouses = (params = {}, options = {}) => {
  // const { companyId, streetId, houseId } = params;

  return useQuery(
    getQueryKeys.housingStockHouses(params),
    () => getHousingStockHouses(params),
    options
  );
};

export default useHousingStockHouses;
